import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-terms-of-use',
  imports: [TranslateModule, RouterLink, NzIconModule],
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss',
})
export class TermsOfUseComponent {
  backLink: string[] = ['..'];
  answers: { answer: string; question: string }[] = [];
  thirdAnswer: string[] = [];
  fourthAnswer: string[] = [];
  isFasdac: boolean = false;

  constructor(translate: TranslateService, dataService: DataService) {
    dataService.companyId$.subscribe((companyId) => {
      if (companyId) {
        this.isFasdac = companyId === '45C41017';
        console.log('isFasdac:', this.isFasdac);
        if (this.isFasdac) {
          this.answers = translate.instant('termsOfUseFasdac.answers');
          this.thirdAnswer = translate.instant('termsOfUseFasdac.thirdQuestion.answers');
        } else {
          this.answers = translate.instant('termsOfUse.answers');
          this.thirdAnswer = translate.instant('termsOfUse.thirdQuestion.answers');
          this.fourthAnswer = translate.instant('termsOfUse.fourthQuestion.answers');
        }
      }
    });
  }
}
